<template>
    <div class="storeinfo">
        <m-title :titlelist="listitem"></m-title>
        <div class="store-box">
            <div class="search-box">
                <div class="search-left">
                    <div class="carplate">
                        <div class="name">充电站</div>
                        <el-select v-model="stationvalue" placeholder="请选择" class="inp" size="small">
                            <el-option v-for="(item, index) in station" :key="index" :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="caraddinfo">
                        <div class="name">充电桩</div>
                        <el-select v-model="devicevalue" placeholder="请选择" class="inp" size="small">
                            <el-option v-for="(item, index) in device" :key="index" :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="adddate">
                        <div class="name">充电开始时间</div>
                        <!-- <el-date-picker v-model="datevalue" type="daterange" range-separator="至" start-placeholder="充电开始时间"
                            end-placeholder="充电结束时间"  value-format="yyyy-MM-dd">
                        </el-date-picker> -->
                        <el-date-picker v-model="starttime" type="date" class="inp" value-format="yyyy-MM-dd"
                            placeholder="充电开始时间">
                        </el-date-picker>
                        至
                        <el-date-picker v-model="endtime" type="date" class="inp" value-format="yyyy-MM-dd"
                            placeholder="充电结束时间">
                        </el-date-picker>
                    </div>
                    <!-- <div class="adddate">
                        <div class="name">充电结束时间</div>
                    </div> -->
                </div>
                <div class="search-right">
                    <button class="chaxun" @click="getsearch">查询</button>
                    <button class="reset" @click="reset">重置</button>
                </div>
            </div>
            <div class="store-title">
                <div class="carlist-box-title">
                    <div class="title-left"></div>
                    <div class="title-right">补能数据</div>
                </div>
                <div class="store-list">
                    <div class="storenumber" @click="gostorelist">
                        <div class="storenum">{{ charge.chargeCount || "暂无数据" }}</div>
                        <div class="storename">充电次数(车次)</div>
                        <img src="../../../assets/homeImg/icon_figer.png" alt="">
                    </div>
                    <div class="storeliang" @click="gostorelist">
                        <div class="storenum">{{ charge.chargeEnergy || "暂无数据" }}</div>
                        <div class="storename">充电电量(度)</div>
                        <img src="../../../assets/homeImg/icon_figer.png" alt="">
                    </div>
                    <div class="storeprice" @click="gostorelist">
                        <div class="storenum">{{ charge.chargeMoney || "暂无数据" }}</div>
                        <div class="storename">充电金额(元)</div>
                        <img src="../../../assets/homeImg/icon_figer.png" alt="">
                    </div>
                    <div class="storelong" @click="gostorelist">
                        <div class="storenum">{{ charge.chargeTime || "暂无数据" }}</div>
                        <div class="storename">充电时长(小时)</div>
                        <img src="../../../assets/homeImg/icon_figer.png" alt="">
                    </div>
                </div>
            </div>
            <div class="store-echarts">
                <div class="echarts-title">
                    <div class="title-left">
                        <div class="left-bac"></div>
                        <div class="left-name">充电统计</div>
                    </div>
                </div>
                <div class="echartsinfo" ref="echartsinfo"></div>
            </div>
            <div class="store-bottom">
                <div class="bottom-left">
                    <div class="left-title">
                        <div class="title-left">
                            <div class="left-bac"></div>
                            <div class="left-name">车辆补能记录</div>
                        </div>
                        <div class="title-right" @click="godetail">
                            查看更多
                        </div>
                    </div>
                    <div class="bot-tabel">
                        <el-table :data="arrlist" style="width: 100%; " height="320" border stripe>
                            <el-table-column prop="plateNumber" label="车牌号" show-overflow-tooltip
                                :render-header="renderHeader"> </el-table-column>
                            <el-table-column prop="driverName" label="司机" show-overflow-tooltip
                                :render-header="renderHeader"> </el-table-column>
                            <el-table-column prop="telephone" label="联系方式" show-overflow-tooltip
                                :render-header="renderHeader"> </el-table-column>
                            <el-table-column prop="startTime" label="开始充电时间" show-overflow-tooltip
                                :render-header="renderHeader">
                            </el-table-column>
                            <el-table-column prop="endTime" label="结束充电时间" show-overflow-tooltip
                                :render-header="renderHeader"> </el-table-column>
                            <el-table-column prop="chargeTime" label="充电时长（分钟）" show-overflow-tooltip
                                :render-header="renderHeader"> </el-table-column>
                            <el-table-column prop="chargePower" label="充电量（度）" show-overflow-tooltip
                                :render-header="renderHeader"> </el-table-column>
                            <el-table-column prop="chargeElecMoney" label="充电金额（元）" show-overflow-tooltip
                                :render-header="renderHeader">
                            </el-table-column>
                            <el-table-column prop="chargeServiceMoney" label="充电服务金额（元）" show-overflow-tooltip
                                :render-header="renderHeader">
                            </el-table-column>
                            <el-table-column prop="chargeMoney" label="充电总金额（元）" show-overflow-tooltip
                                :render-header="renderHeader">
                            </el-table-column>
                        </el-table>

                    </div>
                </div>
                <div class="bottom-right">
                    <div class="carlist-box-title">
                        <div class="title-left"></div>
                        <div class="title-right">当前补能设备情况</div>
                    </div>
                    <div class="bottom-echarts" ref="botecharts"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mTitle from "@/components/mTitle";
import * as echarts from "echarts";
export default {
    components: {
        mTitle,
    },
    data() {
        return {
            listitem: [{ name: "充电补能展示" }],
            station: [],
            stationvalue: '',
            device: [],
            devicevalue: "",
            // datevalue: "",
            endtime: "",
            starttime: "",
            arrlist: [],
            charge: {},//补能数据
            botecharts: null,
            echartsinfo: null,
            //充电统计
            tjoption: {
                color: ['#17B6A1'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                grid: {
                    x: 45,
                    y: 45,
                    x2: 33,
                    y2: 33,
                    borderWidth: 1,
                },
                yAxis: {
                    type: 'value',
                    name: "单位/车次"
                },
                series: [

                    {
                        name: '车次',
                        stack: 'Total',
                        smooth: true,
                        lineStyle: {
                            width: 0
                        },
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: 'rgb(128, 255, 0)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgb(1, 191, 236)'
                                }
                            ])
                        },
                        data: [],
                        type: 'line',

                    }
                ]
            },
            //当前补能设备详情
            botoption: {
                color: ["#86CCDB", '#FFDE6A'],
                tooltip: {
                    trigger: 'item',
                },
                legend: {
                    top: '5%',
                    left: 'center',
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['30%', '55%'],
                        center: ['40%', '45%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center',
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false,
                        },
                        data: [
                        ],
                    },
                    {
                        type: 'pie',
                        radius: ['30%', '40%'], // 调节环的内半径 外半径
                        center: ['40%', '45%'], // 注意 ：这里要与上面外环一致哦
                        label: {
                            show: false,
                            position: 'inside',
                        },
                        z: 2, // 层级要高
                        itemStyle: {
                            normal: {
                                color: 'rgba(0,0,0,0.1)',
                            },
                        },
                        data: [
                        ],
                    },
                ],
            }
        }
    },
    mounted() {
        this.$nextTick((_) => {
            this.botecharts = echarts.init(this.$refs.botecharts);
            this.echartsinfo = echarts.init(this.$refs.echartsinfo);
        })
        this.getdownstation()
        this.getdownDevice()
        this.getchargeecharts()
        this.getsupple()
        this.getEnergyCount()
        this.getEnergylist()
        window.addEventListener("resize", () => {
                this.botecharts.resize();
                this.echartsinfo.resize();
            });
    },
    methods: {
        gostorelist(){
            let obj={}
            obj.starttime=this.starttime
            obj.endtime=this.endtime
            obj.station=this.stationvalue
            obj.piles=this.devicevalue
            this.$router.push({
                name:'caraddstorelist',
                query:{obj:JSON.stringify(obj)}
            })
        },
        //查询
        getsearch() {
            // this.starttime = this.datevalue[0]
            // this.endtime = this.datevalue[1]
            this.getsupple()
            this.getchargeecharts()
        },
        //重置
        reset() {
            this.stationvalue = ""
            this.devicevalue = ""
            // this.datevalue = ""
            this.starttime = ""
            this.endtime = ""
            this.getsupple()
            this.getchargeecharts()
        },
        // 下拉充电桩
        async getdownDevice() {
            const { data } = await this.$http(
                "api1",
                "api/replenish/station/downEnergyDevice",
                "get"
            )
            if (!data || data.code != "0") return;
            this.device = data.data
        },
        // 下拉充电站
        async getdownstation() {
            const { data } = await this.$http(
                "api1",
                "api/replenish/station/downEnergyStation",
                "get"
            )
            if (!data || data.code != "0") return;
            this.station = data.data
        },
        //充电统计
        async getchargeecharts() {
            const { data } = await this.$http(
                "api1",
                "api/replenish/log/chargeStatistics",
                "get",
                { station: this.stationvalue, piles: this.devicevalue }
            )
            if (!data || data.code != "0") return;
            let xarrdata = []
            let y2arrdata = []
            data.data.forEach(item => {
                xarrdata.push(item.days)
                y2arrdata.push(item.chargeCount)
            })
            this.tjoption.xAxis.data = xarrdata
            this.tjoption.series[0].data = y2arrdata

            this.echartsinfo.setOption(this.tjoption);
            // window.onresize = () => {
                
            // };
        },
        // 充电补能数据统计 
        async getsupple() {
            const { data } = await this.$http(
                "api1",
                "api/replenish/log/suppleEnergyStatistics",
                "get",
                { station: this.stationvalue, piles: this.devicevalue, starttime: this.starttime, endtime: this.endtime }
            )
            if (!data || data.code != 0) return
            this.charge = data.data
        },
        // 当前补能设备情况
        async getEnergyCount() {
            const { data } = await this.$http(
                "api1",
                "api/replenish/log/echartsEnergyCount",
                "get"
            )
            if (!data || data.code != "0") return;
            let energyarr = []
            data.data.forEach(item => {
                item.status == 1 ? item.status = '空闲中的设备' : item.status = '充电中设备'
                let obj = {
                    value: "",
                    name: "",
                }
                obj.value = item.pilesCount
                obj.name = item.status
                energyarr.push(obj)
            })
            this.botoption.series[0].data = energyarr
            this.botoption.series[1].data = energyarr
            this.botecharts.setOption(this.botoption);
           
        },
        //查询充电纪录列表 api/replenish/Log/list
        async getEnergylist() {
            const { data } = await this.$http(
                "api1",
                'api/replenish/log/list?limit=10&page=1',
                "get"
            )
            if (!data || data.code != "0") return;
            data.data.list.map(item => {
                item.startTime = this.getSimpleDate(new Date(item.startTime))
                item.endTime = this.getSimpleDate(new Date(item.endTime))
            })
            this.arrlist = data.data.list
        },
        //查看更多
        godetail() {
            this.$router.push({ path: "/energy/addstore/caraddstorelist" })
        },
        // 时间转换
        getSimpleDate(date) {
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            var h = date.getHours();
            var minute = date.getMinutes();
            minute = minute < 10 ? ('0' + minute) : minute;
            var s = date.getSeconds();
            s = s < 10 ? '0' + s : s;
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s;
        },

    },
    beforeDestroy(){
        window.removeEventListener('resize',()=>{
            this.botecharts.resize();
            this.echartsinfo.resize();
        })
    }
}
</script>

<style lang="scss" scoped>
@mixin start {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

@mixin between {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@mixin store($img: img) {
    width: 24%;
    height: 146px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: url($img);
    background-size: 100% 100%;

    .storenum {
        font-size: 200%;
        font-family: PingFang SC;
        font-weight: 600;
        color: #2F419B;
        margin-bottom: 16px;
    }

    .storename {
        font-size: 17px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #2F419B
    }
}

// .el-input__inner {
//     height: 30px !important;
//     line-height: 30px !important;
// }
// .el-input__icon {
//     line-height: 30px !important;
// }
.storeinfo {
    width: 100%;
    height: 100%;

    .store-box {
        width: 100%;
        height: calc(100% - 50px);
        background: #F5F6FA;
        border-radius: 20px;
        overflow: auto;
        padding: 10px;
        box-sizing: border-box;

        .search-box {
            width: 100%;
            padding: 20px 25px;
            box-sizing: border-box;
            @include between;
            background-color: #fff;
            margin-bottom: 10px;
            border-radius: 8px;
            .search-left {
                @include start;

                .carplate,
                .caraddinfo,
                .adddate {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-right: 20px;

                    .name {
                        font-size: 80%;
                        font-family: PingFang SC;
                        font-weight: bold;
                        color: #333333;
                        margin-right: 15px;
                    }

                    .inp {
                        width: 150px;
                        height: 30px;

                        .el-date-editor.el-input {
                            width: 180px !important;
                        }

                        // border-radius: 4px;
                        // display: inline-block;
                        // vertical-align: middle;
                        // width: 160px;
                        // height: 30px;
                        // background: #f3f4f5;
                        // border-radius: 2px;
                    }
                }
            }

            .search-right {
                display: flex;
                justify-content: flex-end;
                align-items: center;

                .chaxun {
                    width: 80px;
                    height: 30px;
                    background: #17B6A1;
                    border-radius: 8px;
                    color: #fff;
                    line-height: 30px;
                    text-align: center;
                    border: none;
                    font-size: 80%;
                }

                .reset {
                    width: 80px;
                    height: 30px;
                    background-color: #F5F6FA;
                    border-radius: 8px;
                    color: #17B6A1;
                    line-height: 30px;
                    text-align: center;
                    border: none;
                    font-size: 80%;
                    margin-left: 19px;
                }
            }
        }

        .store-title {
            width: 100%;
            height: 260px;
            background: #FFFFFF;
            border-radius: 20px;
            padding: 0 34px;
            box-sizing: border-box;

            .carlist-box-title {
                @include start;
                padding: 29px 0;

                .title-left {
                    width: 12px;
                    height: 26px;
                    background: #17B6A1;
                    border-radius: 6px;
                    margin-right: 11px;
                }

                .title-right {
                    font-size: 20px;
                    font-family: PingFang SC;
                    font-weight: 600;
                    color: #2D3748;
                }
            }

            .store-list {
                @include between;

                .storenumber {
                    
                    @include store('../../../assets/buneng/cdcs_pic.png');
                    position: relative;
                    cursor: pointer;
                    img{
                        width: 20px;
                        height: 30px;
                        position: absolute;
                        right: 15px;
                        bottom: 15px; 
                    }
                }

                .storeliang {
                    @include store('../../../assets/buneng/cddl_pic@2x (1).png');
                    position: relative;
                    cursor: pointer;
                    img{
                        width: 20px;
                        height: 30px;
                        position: absolute;
                        right: 15px;
                        bottom: 15px; 
                    }
                }

                .storeprice {
                    @include store('../../../assets/buneng/cdje_pic.png');
                    position: relative;
                    cursor: pointer;
                    img{
                        width: 20px;
                        height: 30px;
                        position: absolute;
                        right: 15px;
                        bottom: 15px; 
                    }
                }

                .storelong {
                    @include store('../../../assets/buneng/cdsc_pic.png');
                    position: relative;
                    cursor: pointer;
                    img{
                        width: 20px;
                        height: 30px;
                        position: absolute;
                        right: 15px;
                        bottom: 15px; 
                    }
                }
            }
        }

        .store-echarts {
            width: 100%;
            height: 482px;
            background: #FFFFFF;
            border-radius: 20px;
            margin-top: 20px;
            padding: 0 34px;
            box-sizing: border-box;

            .echarts-title {
                padding: 25px 0 20px 0;
                box-sizing: border-box;
                @include between;

                .title-left {
                    @include start;

                    .left-bac {
                        width: 12px;
                        height: 26px;
                        background: #17B6A1;
                        border-radius: 6px;
                        margin-right: 11px;
                    }

                    .left-name {
                        font-size: 20px;
                        font-family: PingFang SC;
                        font-weight: 600;
                        color: #2D3748;
                    }
                }

                .title-right {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;

                    .tjstyle {
                        width: 80px;
                        height: 30px;
                        border: 1px solid #17B6A1;
                        border-radius: 8px;
                        text-align: center;
                        line-height: 30px;
                        font-size: 80%;
                        color: #17B6A1;
                        margin-left: 17px;
                    }

                    .active {
                        width: 80px;
                        height: 30px;
                        border: 1px solid #17B6A1;
                        border-radius: 8px;
                        text-align: center;
                        line-height: 30px;
                        font-size: 80%;
                        color: #fff;
                        background-color: #17B6A1;
                        margin-left: 17px;
                    }
                }
            }

            .echartsinfo {
                height: calc(100% - 90px);
                width: 100%;
            }
        }

        .store-bottom {
            width: 100%;
            height: 412px;
            margin-top: 20px;
            @include start;

            .bottom-left {
                width: 69%;
                height: 412px;
                background: #FFFFFF;
                border-radius: 20px;

                .left-title {
                    padding: 25px 34px 13px 34px;
                    box-sizing: border-box;
                    @include between;

                    .title-left {
                        @include start;

                        .left-bac {
                            width: 12px;
                            height: 26px;
                            background: #17B6A1;
                            border-radius: 6px;
                            margin-right: 11px;
                        }

                        .left-name {
                            font-size: 20px;
                            font-family: PingFang SC;
                            font-weight: 600;
                            color: #2D3748;
                        }
                    }

                    .title-right {
                        width: 80px;
                        height: 30px;
                        background: #17B6A1;
                        border-radius: 8px;
                        line-height: 30px;
                        font-size: 80%;
                        text-align: center;
                        color: #fff;
                        cursor: pointer;
                    }
                }

                .bot-tabel {
                    height: calc(100% - 80px);
                    overflow: scroll;
                }
            }

            .bottom-right {
                width: 30%;
                height: 412px;
                background: #FFFFFF;
                border-radius: 20px;
                margin-left: 20px;
                padding-left: 34px;
                box-sizing: border-box;

                .carlist-box-title {
                    @include start;
                    padding: 25px 0;

                    .title-left {
                        width: 12px;
                        height: 26px;
                        background: #17B6A1;
                        border-radius: 6px;
                        margin-right: 11px;
                    }

                    .title-right {
                        font-size: 20px;
                        font-family: PingFang SC;
                        font-weight: 600;
                        color: #2D3748;
                    }
                }

                .bottom-echarts {
                    width: 100%;
                    height: calc(100% - 75px);
                }
            }
        }
    }
}
</style>